import { RxCustomerAPI } from '@driftt/dapper'
import { Geolocation } from './models'

export const fetchGeolocation = () => {
  return RxCustomerAPI
    .get('/location')
    .checkStatus()
    .retryWithBackoff()
    .mapResponse(location => new Geolocation(location))
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/geolocation/api.js